const initialState = {
    historyData: [],
    pageNo: 0,
    totalCount: 0,
    sortFilterVal: "desc",
    isLoading: false,
    reloadPage:"random"
}

const searchHistoryReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'historydata':
            state ={...state, isLoading: false}
            state = { ...state, historyData: action.payload };
            return state;
        case 'loadmorepages':
            state ={...state, isLoading: true}
            state = { ...state, pageNo: action.payload };
            return state;
        case 'historydataTotalCount':
            state = { ...state, totalCount: action.payload };
            return state;
        case 'historydataSortFilter':
            state = { ...state, sortFilterVal: action.payload };
            return state;
        case 'reloadHistoryPage':
            state = { ...state, reloadPage: action.payload };
            return state;
            case 'HPloading':
                state ={...state, isLoading: true}
                return state;
        default:
            return state;
    }
}

export default searchHistoryReducer;